import React, {
  useState,
  useLayoutEffect,
} from 'react';
import { useNavigate } from "react-router-dom";
import { Autocomplete } from 'devextreme-react/autocomplete';
import {
  DataGrid,
  Column,
  Editing,
  MasterDetail,
} from 'devextreme-react/data-grid';
import DxGrid from "devextreme/ui/data_grid";
import Popup from "devextreme-react/popup";
import LoadPanel from 'devextreme-react/load-panel';
import { TextBox as TB, Button as TextBoxButton } from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import TextBox from "devextreme/ui/text_box";
import Button from 'devextreme-react/button';
import CheckBox from 'devextreme-react/check-box';
import DateBox from 'devextreme-react/date-box';
import {
  Validator,
  PatternRule
} from 'devextreme-react/validator';
import ValidationGroup from 'devextreme-react/validation-group';
import { appConst } from '../../app-const';
import { useStaffListApiService } from '../../services';
import { useGlobalState } from '../../contexts/global-state';
import { usePageTitle } from '../../contexts/page-title';
import '../../components/component.scss';
import './add-staff-request.scss';
import { showError, showSuccess } from '../../helpers/ui';
import { useScreenSize } from '../../utils/media-query';


export default function () {
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [showLoadingPanel, setShowLoadingPanel] = useState(false);
  const [showCurrentSchoolsPopup, setShowCurrentSchoolsPopup] = useState(false);
  const [currentSchools, setCurrentSchools] = useState([]);
  const [selectedMember, setSelectedMember] = useState();
  const [mainLocation, setMainLocation] = useState(true);
  const [divisionId, setDivisionId] = useState();
  const { lookupData } = useGlobalState();
  const { findMemberByNameAsync, requestSchoolAssociationAdditionAsync, getStaffListBySchoolAsync } = useStaffListApiService();
  const { selectedSchool, defaultSuggestedSAStartAndEndDates, managedSchools, setSelectedSchool } = useGlobalState();
  const { setTitle } = usePageTitle();
  const navigate = useNavigate();
  const { isXSmall, isSmall } = useScreenSize();
  const isCardView = isXSmall || isSmall;

  useLayoutEffect(() => setTitle("Add Staff"), [setTitle]);

  function autoCompleteItemRender(item) {
    return (
      <div className="item-container">
        <div>{item.fullName}</div>
        <div className="push-to-right">{item.primarySchool}</div>
      </div>
    );
  }

  const yesNoLookup = [
    { id: true, name: "Yes" },
    { id: false, name: "No" }
  ];


  const renderCardRow = (rowInfo) => {
    const { data, key } = rowInfo;
    return (
      <tr>
        <td colSpan={100} style={{ padding: 0, width: "100%", verticalAlign: "top" }}>
          <div className="small-screen-card-container">
            <div className="small-screen-card-item-container">
              <div>{data.name}</div>
            </div>
            <div className="small-screen-card-item-container">
              <div>Start Date: {new Intl.DateTimeFormat('en-CA').format(new Date(data.startDate))}</div>
            </div>
            <div className="small-screen-card-item-container">
              <div>Main Location: <CheckBox value={data.primary} /></div>
            </div>
            <div className="small-screen-card-item-container">
              <b>Remove:</b>
              <SelectBox
                items={yesNoLookup}
                displayExpr="name"
                valueExpr="id"
                value={data.remove}
                onValueChanged={(e) => {
                  if (typeof (e.event) === 'undefined') return;
                  const value = e.value;
                  let tmp = [...currentSchools];
                  let el = tmp.find(x => x.schoolAssociationId === key);
                  if (el) {
                    el.remove = value;
                    setCurrentSchools(tmp);
                  }
                }}
                style={{ width: "70%" }}
              />
            </div>
          </div>
        </td>
      </tr>
    );
  };

  function showCurrentSchools() {
    const title = selectedMember && `Our records show that ${selectedMember.fullName} currently works at these locations.  For each location, please indicate whether they should be removed from that staff list.`;
    return (
      <Popup
        visible={showCurrentSchoolsPopup}
        showCloseButton={true}
        onHiding={(e) => {
          setShowCurrentSchoolsPopup(false);
        }}
        width={(isCardView) ? "100%" : "75%"}
        height={(isCardView) ? "100%" : "75%"}
        showTitle={true}
        title={selectedSchool && selectedSchool.name}
        toolbarItems={[
          {
            widget: 'dxButton',
            toolbar: 'bottom',
            location: 'center',
            options: {
              text: 'Save',
              type: 'default',
              onClick: () => {
                let tmp = [...selectedMembers];
                let item = { ...selectedMember };
                item.startDate = defaultSuggestedSAStartAndEndDates.defaultStartDate;
                item.currentSchoolActions = [...currentSchools]
                item.mainLocation = mainLocation;
                item.divisionId = divisionId;
                tmp.push(item);
                setSelectedMembers(tmp);
                setShowCurrentSchoolsPopup(false);
              }
            }
          },
          {
            widget: 'dxButton',
            toolbar: 'bottom',
            location: 'center',
            options: {
              text: 'Cancel',
              onClick: () => {
                setCurrentSchools([]);
                setShowCurrentSchoolsPopup(false);
              }
            }
          }
        ]}
      >
        <p>{title}</p>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span style={{ lineHeight: 1.2 }}>{(isCardView) ? <>Is <strong>{selectedSchool?.name}</strong> the staff member&apos;s <br /> main school location?</> : <>Is <strong>{selectedSchool?.name}</strong> the staff member&apos;s main school location?</>}</span>
          <SelectBox
            width={(isCardView) ? "25%" : "10%"}
            dataSource={yesNoLookup}
            defaultValue={true}
            valueExpr="id"
            displayExpr="name"
            onValueChanged={(e) => {
              if (e.event === undefined) return;
              setMainLocation(e.value)
            }}
          />

        </div>
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <SelectBox
            placeholder="Select division.."
            dataSource={lookupData.divisions}
            valueExpr="value"
            displayExpr="text"
            onValueChanged={
              (e) => {
                if (typeof e.event === "undefined") return;

                setDivisionId(e.value);
              }
            }
          />
        </div>
        <DataGrid
          dataSource={currentSchools}
          keyExpr="schoolAssociationId"
          showBorders={false}
          height="60%"
          columnHidingEnabled={true}
          wordWrapEnabled={true}
          repaintChangesOnly={false}
          dataRowRender={isCardView ? renderCardRow : undefined}
          showColumnHeaders={!isCardView}
        >
          <Editing
            allowAdding={false}
            allowDeleting={false}
            allowUpdating={true}
            mode="cell"
            startEditAction="click"
          />
          <Column
            caption="Location Name"
            dataType="text"
            dataField="name"
            allowEditing={false}
            width="50%"
          />
          <Column
            caption="Start Date"
            dataType="date"
            dataField="startDate"
            allowEditing={false}
            width="20%"
            format={appConst.dateDisplayFormat}
          />
          <Column
            caption="Main Location"
            dataType="boolean"
            dataField="primary"
            allowEditing={false}
            cellRender={({ value }) => (
              <input type="checkbox" checked={value} readOnly />
            )}
            width="15%"
            lookup={{
              dataSource: { yesNoLookup },
              valueExpr: "id",
              displayExpr: "name"
            }}
          />
          <Column
            caption="Remove?"
            dataType="boolean"
            dataField="remove"
            width="15%"
            showEditorAlways={true}
            editorOptions={{
              searchEnabled: false
            }}
            lookup={{
              dataSource: yesNoLookup,
              valueExpr: "id",
              displayExpr: "name",
            }}
          />
        </DataGrid>
      </Popup>
    )
  }

  function onValueChanged(e, key, property) {
    if (typeof (e.event) === 'undefined') return;
    const value = e.value;
    let tmp = [...selectedMembers];
    let el = tmp.find(x => x.id === key);
    if (el) {
      el[property] = value;
      setSelectedMembers(tmp);
    }
  }

  const renderCardRowProcessGrid = (rowInfo) => {
    const { data, key } = rowInfo;
    const { fullName } = data;

    return (
      <tr>
        <td colSpan={100} style={{ padding: 0, width: "100%", verticalAlign: "top" }}>
          <div className="small-screen-card-container">
            <div className="small-screen-card-item-container" style={{ justifyContent: "space-between" }}>
              <div>{data.fullName ? data.fullName : data.emailAddress}</div>
              <Button
                icon="trash"
                onClick={
                  (e) => {
                    let tmp = [...selectedMembers];
                    const index = tmp.findIndex(x => x.id === key);
                    if (index !== -1) {
                      tmp.splice(index, 1);
                      setSelectedMembers(tmp);
                    }
                  }
                }
              />
            </div>
            {fullName && <div className="small-screen-card-item-container">
              <div>Start Date:</div>
              <DateBox
                displayFormat={appConst.dateDisplayFormat}
                value={data.startDate}
                width="75%"
                style={{ marginLeft: "auto" }}
                onValueChanged={(e) => {
                  onValueChanged(e, key, "startDate");
                }}
              />
            </div>}
            {fullName && <div className="small-screen-card-item-container">
              <div>Main Location:</div>
              <SelectBox
                defaultValue={data.mainLocation}
                dataSource={yesNoLookup}
                valueExpr="id"
                displayExpr="name"
                onValueChanged={(e) => {
                  if (e.event === undefined) return;

                  onValueChanged(e, key, "mainLocation");
                }}
              />
            </div>}
            {fullName && <div className="small-screen-card-item-container">
              <div>Division:</div>
              <SelectBox
                dataSource={lookupData.divisions}
                displayExpr="text"
                valueExpr="value"
                value={data.divisionId}
                onValueChanged={(e) => {
                  onValueChanged(e, key, "divisionId");
                }}
                width="75%"
                style={{ marginLeft: "auto" }}
              />
            </div>}
            {fullName && data.currentSchools?.length > 0 &&
              <div className="small-screen-card-item-container" style={{ justifyContent: "space-between"}}>
                <div>Current Locations</div>
                <div>Remove?</div>
              </div>}
            {fullName && data?.currentSchoolActions?.map((item, index) => (
              <div className="small-screen-locations-remove" key={index}>
                <div className="small-screen-card-location-name" title={item.name}>
                  {item.name}
                </div>
                <SelectBox
                  dataSource={yesNoLookup}
                  displayExpr="name"
                  valueExpr="id"
                  value={item.remove}
                  width="75px"
                  onValueChanged={(e) => {
                    if (typeof (e.event) === 'undefined') return;
                    const value = e.value;
                    let tmp = [...selectedMembers];
                    let el = tmp.find(x => x.id === key);
                    if (el) {
                      el.currentSchools[index].remove = value;
                      setSelectedMembers(tmp);
                    }
                  }}
                />
              </div>
            ))}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <div className="responsive-paddings">
      <p id="message1">{"Enter the name of the member that you want to send the sign-up link to, one per line:"}</p>
      <Autocomplete
        id="memberAutoComplete"
        dataSource={findMemberByNameAsync()}
        valueExpr="fullName"
        searchExpr={["PreferredFirstName", "FirstName", "LastName", "FullName", "LegalFullName"]}
        maxItemCount={250}
        placeholder="Type Name..."
        itemRender={autoCompleteItemRender}
        // onItemClick (not onSelectionChanged) so a member is only added when the user
        // picks it from the list, not when the typed text happens to match a full name.
        onItemClick={(e) => {
          const selectedItem = e.itemData;
          if (selectedItem) {
            const found = selectedMembers.find(item => item.id === selectedItem.id);
            if (found) {
              showError("Member is already in the processing list.");
              return;
            }

            if (selectedItem.currentSchools.length > 0) {
              setSelectedMember(selectedItem);
              setShowCurrentSchoolsPopup(true);
              setCurrentSchools(selectedItem.currentSchools);
            }
            else {
              let tmp = [...selectedMembers];
              let item = { ...selectedItem };
              item.startDate = defaultSuggestedSAStartAndEndDates.defaultStartDate;
              item.divisionId = null;
              tmp.push(item);
              setSelectedMembers(tmp);
            }
            e.component.reset();
          }
        }}
      >
      </Autocomplete>
      <p id="message2">{"If you can't find a member by searching above (for example, if the staff member hasn't worked in Edmonton Public before), you can type their email address below."}</p>
      <ValidationGroup>
        <TB
          id="emailTextBox"
        >
          <TextBoxButton
            name="addEmail"
            location="after"
            options={
              {
                icon: 'add',
                type: 'default',
                onClick: (e) => {
                  let el = document.getElementById("emailTextBox");
                  let tb = TextBox.getInstance(el);
                  let emailTxt = tb.option('value');
                  if ('' === emailTxt || !tb.option("isValid")) return;
                  tb.reset();

                  let tmp = [...selectedMembers];
                  const email = {
                    emailAddress: emailTxt,
                    id: -Math.floor(Math.random() * 1000) - 1, // generate a random negative id to prevent conflicts with actual member ids
                  }
                  tmp.push(email);
                  setSelectedMembers(tmp);
                }
              }
            }
          />
          <Validator>
            <PatternRule
              pattern={appConst.emailPattern}
              message={appConst.emailValidationMessage}
            />
          </Validator>
        </TB>
      </ValidationGroup>
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        visible={showLoadingPanel}
      />
      <div style={{ marginTop: '25px' }}>
        <DataGrid
          id="processGrid"
          keyExpr="id"
          dataSource={selectedMembers}
          columnHidingEnabled={true}
          dataRowRender={isCardView ? renderCardRowProcessGrid : undefined}
          showColumnHeaders={!isCardView}
          className={isCardView ? "small-screen" : ""}
          scrolling={{ mode: "standard" }}
          onEditorPreparing={
            (e) => {
              if (e.row.rowType === 'data' && e.row.data.hasOwnProperty(e.dataField)) {
                e.editorOptions.disabled = false;
              } else {
                e.editorOptions.disabled = true;
              }
            }
          }
          onCellPrepared={(e) => {
            if (e.column.type === "detailExpand" && e.cellElement) {
              e.cellElement.setAttribute("title", "Click to show current schools");
            }
          }}
          onRowExpanding={(e) => {
            if (!e.component.option('masterDetail.enabled')) return;
            const member = selectedMembers.find(x => x.id === e.key);
            if (member?.currentSchools?.length === 0) {
              e.cancel = true; // prevent opening
            }
          }}
        >
          <Editing
            allowAdding={false}
            allowDeleting={true}
            allowUpdating={true}
            mode={(isCardView) ? "popup" : "cell"}
            startEditAction="click"
          />
          <Column
            dataField="fullName"
            allowEditing={false}
          />
          <Column
            dataField="startDate"
            dataType="date"
            format={appConst.dateDisplayFormat}
            allowEditing={true}
          />
          <Column
            dataField="mainLocation"
            caption="Main Location"
            dataType="boolean"
            lookup={{
              dataSource: yesNoLookup,
              valueExpr: "id",
              displayExpr: "name",
            }}
          />
          <Column
            dataField="divisionId"
            caption="Division"
            dataType="number"
            allowEditing={true}
            lookup={{
              dataSource: lookupData.divisions,
              valueExpr: "value",
              displayExpr: "text",
            }} />
          <Column
            dataField="emailAddress"
            allowUpdating={false}
          />
          <MasterDetail
            enabled={true}
            component={({ data }) => (
              <>
                <p style={{ margin: '5px' }}>{data.data.fullName} currently works at these locations</p>
                <DataGrid
                  dataSource={data.data.currentSchools}
                  showBorders={true}
                >
                  <Editing
                    allowAdding={false}
                    allowDeleting={false}
                    allowUpdating={true}
                    mode="cell"
                    startEditAction="click"
                  />
                  <Column
                    caption="Location Name"
                    dataType="text"
                    dataField="name"
                    allowEditing={false}
                  />
                  <Column
                    caption="Remove?"
                    dataType="boolean"
                    dataField="remove"
                    showEditorAlways={true}
                    editorOptions={{
                      searchEnabled: false
                    }}
                    lookup={{
                      dataSource: yesNoLookup,
                      valueExpr: "id",
                      displayExpr: "name",
                    }} />
                </DataGrid>
              </>
            )}
          />
        </DataGrid>
      </div>
      <Button
        className="send-button"
        id="send"
        type="default"
        text="Process"
        onClick={
          async (e) => {
            if (selectedMembers.length === 0) {
              showError('There is no data to process.');
              return;
            }
            let el = document.getElementById("processGrid");
            let grd = DxGrid.getInstance(el);
            grd.saveEditData();

            setShowLoadingPanel(true);
            let members = selectedMembers.filter(function (e) {
              if (e.hasOwnProperty('fullName')) {
                return e;
              } else {
                return null;
              }
            }).map(a => ({ Id: a.id, StartDate: a.startDate, CurrentSchoolActions: a.currentSchoolActions, MainLocation: a.mainLocation, SchoolId: selectedSchool.schoolId, DivisionId: a.divisionId }));
            let emails = selectedMembers.filter(function (e) {
              if (e.hasOwnProperty('emailAddress')) {
                return e;
              } else {
                return null;
              }
            }).map(a => a.emailAddress);
            try {
              e.component.option("disabled", true);
              const r = await requestSchoolAssociationAdditionAsync(selectedSchool.schoolId, members, emails);
              if (r.data) {
                showSuccess('Email has been sent.')
                const school = managedSchools.find(s => s.schoolId === parseInt(selectedSchool.schoolId));
                school && (getStaffListBySchoolAsync(selectedSchool.schoolId).then(r => {
                  school.staffList = r.data;
                  setSelectedSchool(school);
                  navigate(-1);
                }));
              } else {
                showError('There was an error sending the data.')
              }
              e.component.option("disabled", false);
              setShowLoadingPanel(false);
            } catch (error) {
              showError(error.message)
              e.component.option("disabled", false);
              setShowLoadingPanel(false);
            }
          }
        }
      />
      {showCurrentSchools()}
    </div>
  );
}